'use client';

import { c as _c } from "react/compiler-runtime";
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';
import { flagsContext } from '@/contexts/flagsContext';
import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';
export const LaunchDarklyProvider = props => {
  const $ = _c(31);
  const {
    isDev,
    isDemo,
    isTest,
    launchDarklyClientId
  } = useEnvironment();
  const {
    currentProjectId,
    user
  } = useUser();
  if (!currentProjectId) {
    return props.children;
  }
  if (isDemo || isDev || isTest) {
    const t0 = !isDemo;
    const t1 = !isDemo;
    const t2 = isDev || isDemo;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        view: true,
        trend: true,
        export: true,
        audit: false
      };
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        mode: "agent_only"
      };
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== isDev || $[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
      t5 = {
        NonCognitoEonAccounts: false,
        SkipOnboarding: false,
        dlsgFrontend: false,
        LlgFrontend: false,
        InventoryStatusColumns: isDev,
        GcpPermissionGroupEnforcement: true,
        enableHourlyBackup: false,
        AzureSqlVirtualMachineSupport: true,
        AzureSqlManagedInstanceSupport: true,
        MySqlFlexibleServerSupport: true,
        ownCustomerOnboardingEnabled: false,
        hourlyDlsgPolicyEnabled: false,
        SecurityFindings: true,
        AllowAccountLevelSamlWhenOrgAttached: false,
        InventoryFilterOmnibox: true,
        EnableGDSGPage: isDev,
        EnableGdsgNotifications: false,
        StorageGatewayCostExplorer: isDev,
        CostExplorerUsdToOtherCurrencies: isDev,
        EnableGdsgObjectActions: false,
        EnableGdsgInventoryReports: isDev,
        SupportColdTierVaults: true,
        AiAssistantSidebar: isDev,
        SapHanaPitrSupport: true,
        MongoAtlasSupport: true,
        MongoAtlasNonAwsClusters: isDev,
        MongoAtlasAdvancedRestoreEnabled: isDev,
        GcpSqlVirtualMachineSupport: true,
        ExploreFilesForDatabaseVms: true,
        RdsRestoreWithoutEncryptionEnabled: false,
        RecordRestoreResultsEnabled: true,
        GcpVmHighFrequencyBackupEnabled: true,
        RdsHighFrequencyBackupEnabled: true,
        EnableCrossCloudKvRecordRestore: true,
        EnableCrossCloudKvRecordRestoreAzure: true,
        AzureSnapshotsDiscoverySupport: true,
        AzureAdeBackupSupport: true,
        AzureVmDesRestoreSupport: true,
        AzureMssqlTdeCmkRestore: true,
        AwsRdsNativeBackupSupport: true,
        ShadowClassificationPolicy: true,
        AwsEksClusterBackupSupport: true,
        AzureMultipleAppRegistrations: false,
        AzureCustomPermissionsModel: false,
        GoogleWorkspaceSupport: true,
        GoogleWorkspaceEnableRansomwareDetection: true,
        GwsInPlaceRestoreOnly: false,
        GwsRestoreToTargetMailbox: true,
        GwsRestoreToTargetDrive: true,
        GwsRestoreWholeSharedDrive: true,
        Microsoft365Support: true,
        Microsoft365RestoreSupport: true,
        EnableRansomwareDetectionM365: true,
        M365TeamsSupport: true,
        M365TeamsChatsSupport: t0,
        M365RestoreToAnotherUser: true,
        EntraIdSupport: true,
        EntraIdApplicationEstate: t1,
        EntraIdAdministrativeUnits: false,
        UnifiedSearch: t2,
        EnableMrapForByov: true,
        BigQueryNativeRestoreEnabled: true,
        EnableBigQueryNativePolicy: true,
        GcpProjectLabelTagFilterEnabled: true,
        CancelBackupJobEnabled: true,
        BigQueryRestoreOverwriteEnabled: true,
        SensitivityAnnotations: true,
        EnableNetworkClassification: true,
        RdsRestorePreserveOriginalMemberNames: false,
        CassandraSupport: true,
        DataPlatformConsoleEnabled: true,
        DataEngineDefaultLanding: false,
        RdsCdcUiEnabled: true,
        LakehouseMetricExportEnabled: true,
        RolePermissionFamiliesEnabled: true,
        UnifiedIdentityRestore: true,
        AiAgents: isDev,
        AiDashboardsSupport: isDev,
        ZeroEtlEnabled: true,
        LakehouseEnabled: false,
        ZeroEtlMultiResourcePolicies: false,
        ZeroEtlBackupPolicyLink: true,
        ZeroEtlIntegrationsEnabled: true,
        DataKnowledgeGraphEnabled: false,
        AgenticDataLayerEnabled: false,
        LakehouseCustomerOwnedCatalogs: false,
        StreamlakeLakehouseScreens: true,
        StreamlakePipelineCostChartsEnabled: isDev,
        StreamlakePipelineStorageAPICostChartsEnabled: false,
        StreamlakePipelineTuning: false,
        EnableExportAccessDeniedItems: true,
        InventoryIssuesColumn: false,
        RestoreTemplates: true,
        BulkRestore: true,
        EnableYaraScan: true,
        RemediationOrchestration: true,
        EnableInventoryEntitiesFilter: true,
        DataClassificationCredentialsEnabled: false,
        SaasInventoryDefaultLanding: false,
        BackupComplianceJson: t3,
        EnableSnapshotArchitect: true,
        UseTargetVpcForRestoreServer: true,
        UseTargetVpcForFileRestoreServer: true,
        EnableGcpInstantRestore: true,
        ShovalCdcMode: t4,
        PolicyAndVaultMetadataLabels: true
      };
      $[2] = isDev;
      $[3] = t0;
      $[4] = t1;
      $[5] = t2;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {};
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    let t7;
    if ($[8] !== t5) {
      t7 = {
        flags: t5,
        flagKeyMap: t6,
        ldClient: undefined
      };
      $[8] = t5;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== props.children || $[11] !== t7) {
      t8 = <flagsContext.Provider value={t7}>{props.children}</flagsContext.Provider>;
      $[10] = props.children;
      $[11] = t7;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    return t8;
  }
  if (!launchDarklyClientId || !user?.eonAccount) {
    return props.children;
  }
  let t0;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      reactContext: flagsContext,
      useCamelCaseFlagKeys: false
    };
    $[13] = t0;
  } else {
    t0 = $[13];
  }
  let t1;
  if ($[14] !== currentProjectId || $[15] !== user.eonAccount.domain || $[16] !== user.eonAccount.name) {
    t1 = {
      key: currentProjectId,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain
    };
    $[14] = currentProjectId;
    $[15] = user.eonAccount.domain;
    $[16] = user.eonAccount.name;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  let t2;
  if ($[18] !== currentProjectId || $[19] !== user.eonAccount.domain || $[20] !== user.eonAccount.id || $[21] !== user.eonAccount.name) {
    t2 = {
      key: user.eonAccount.id,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain,
      projectId: currentProjectId
    };
    $[18] = currentProjectId;
    $[19] = user.eonAccount.domain;
    $[20] = user.eonAccount.id;
    $[21] = user.eonAccount.name;
    $[22] = t2;
  } else {
    t2 = $[22];
  }
  let t3;
  if ($[23] !== t1 || $[24] !== t2) {
    t3 = {
      kind: "multi",
      user: t1,
      organization: t2
    };
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  let t4;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      streaming: false
    };
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  let t5;
  if ($[27] !== launchDarklyClientId || $[28] !== props.children || $[29] !== t3) {
    t5 = <LDProvider reactOptions={t0} clientSideID={launchDarklyClientId} timeout={2} context={t3} options={t4}>{props.children}</LDProvider>;
    $[27] = launchDarklyClientId;
    $[28] = props.children;
    $[29] = t3;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  return t5;
};